import { Component, EventEmitter, Output } from "@angular/core";

@Component({
  selector: "vw-error-page",
  templateUrl: "./error-page.component.html",
})
export class ErrorPageComponent {
  @Output() tryAgain$ = new EventEmitter<void>();

  constructor() {}

  tryAgain(): void {
    this.tryAgain$.emit();
  }
}
